import {
  ComponentWithAs,
  Grid,
  GridItem,
  Icon,
  IconProps,
  Square,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Conference, Feedback, Money } from '../../icons/ContinuIcons';

import { useTranslation } from 'react-i18next';

interface CustomGridItemProps {
  label: string;
  icon: ComponentWithAs<'svg', IconProps>;
  colSpan: number;
}

function CustomGridItem({ label, icon, colSpan }: CustomGridItemProps) {
  return (
    <GridItem
      colSpan={colSpan}
      padding={4}
      border="1px solid"
      borderColor="neutral.100"
      borderRadius="8px"
    >
      <Stack spacing={2}>
        <Square size="18px" borderRadius="3px" bgGradient="linear(to-br, #B466F9, #EBB6BA)">
          <Icon as={icon} color="white" boxSize={3} />
        </Square>

        <Text fontSize="12px" fontWeight={500} color="baseBlack">
          "{label}"
        </Text>
      </Stack>
    </GridItem>
  );
}

export default function AIAgentSuggestionGrid() {
  const { t } = useTranslation();

  const suggestionOptions = [
    {
      label: t('aiAgent.exampleOne'),
      icon: Money,
    },
    {
      label: t('aiAgent.exampleTwo'),
      icon: Feedback,
    },
    {
      label: t('aiAgent.exampleThree'),
      icon: Conference,
    },
  ];

  return (
    <Grid
      height="200px"
      width="full"
      templateRows="repeat(2, 1fr)"
      templateColumns="repeat(2, 1fr)"
      gap={2}
    >
      <CustomGridItem
        colSpan={1}
        label={suggestionOptions[0].label}
        icon={suggestionOptions[0].icon}
      />
      <CustomGridItem
        colSpan={1}
        label={suggestionOptions[1].label}
        icon={suggestionOptions[1].icon}
      />
      <CustomGridItem
        colSpan={2}
        label={suggestionOptions[2].label}
        icon={suggestionOptions[2].icon}
      />
    </Grid>
  );
}
